import { useEffect } from 'react';
import './Home.css';
import { useTheme } from '../hooks/useTheme';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import '../styles/PublicPages.css';

function Home() {
	const { isDarkMode } = useTheme();
	const featuresRef = useScrollAnimation();
	const dashboardRef = useScrollAnimation();
	const demoRef = useScrollAnimation();

	useEffect(() => {
		// Add fade-in animation class after component mounts
		const heroText = document.querySelector('.hero-text');
		heroText.classList.add('fade-in');
	}, []);

	const featureCards = [
		{
			id: 1,
			title: 'Team Planning and Management',
			description:
				'Ensure that your team is always on the same page with our team planning and management tools.',
			image: require(`../assets/${
				isDarkMode ? 'Icon_Gradient' : 'Icon_Primary'
			}.png`),
		},
		{
			id: 2,
			title: 'Events and Announcements',
			description:
				"Ensure your users stay up to date with Events and Announcements. With the ability to RSVP and add to the device's calendar they will be sure to never miss a thing!",
			image: require(`../assets/${
				isDarkMode ? 'Icon_Gradient' : 'Icon_Primary'
			}.png`),
		},
		{
			id: 3,
			title: 'File Sharing and Storage',
			description:
				'Store all of your files in one place and share them with your team and users in a secure and easy to use platform.',
			image: require(`../assets/${
				isDarkMode ? 'Icon_Gradient' : 'Icon_Primary'
			}.png`),
		},
		{
			id: 4,
			title: 'Ministry Check-Ins',
			description:
				'Track attendance throughout custom mistries by allowing users to check-in themselves or family members!',
			image: require(`../assets/${
				isDarkMode ? 'Icon_Gradient' : 'Icon_Primary'
			}.png`),
		},
	];

	return (
		<div className='home'>
			<section className='hero'>
				<img
					src={require('../assets/cover-graphic.png')}
					alt='Cover'
					className='cover-image'
				/>
				<div className='hero-text'>
					<h1>Your church. Your community. Your app.</h1>
					<p>
						Connect with your congregation like never before at the
						ease of your fingertips.
					</p>
				</div>
			</section>

			<section
				className='features'
				ref={featuresRef}>
				<div className='features-left'>
					<h2>Our Powerful Features</h2>
					<p>
						Our robust features allow you to connect to your
						congregation like never before, allowing them to take
						your church with them on the go!
					</p>
					<p>
						Tools that allow guests and members alike to feel
						welcomed and connected to your church.
					</p>
				</div>
				<div className='features-grid'>
					{featureCards.map((card) => (
						<div
							key={card.id}
							className='feature-card'>
							<div className='header'>
								<h3>{card.title}</h3>
							</div>
							<p>{card.description}</p>
						</div>
					))}
				</div>
			</section>

			<section
				className='dashboard-preview'
				ref={dashboardRef}>
				<div className='info-section'>
					<h2>Manage your Church with an intuitive dashboard</h2>
					<p>
						With our Admin portal you will be able to completely
						customize your users experience to maintain your
						branding, and ensure that the users stay up to date and
						connected.
					</p>
				</div>
				<div className='video-container'>
					<img
						src={require('../assets/dashboard-screen.png')}
						alt='Dashboard Preview'
						className='dashboard-preview-image'
					/>
				</div>
			</section>

			<section
				className='demo'
				ref={demoRef}>
				<div className='demo-content'>
					<h2>Get Started with Assemblie Today!</h2>
					<p>Reach out and start increasing engagement today!</p>
					<button
						className='contact-btn'
						onClick={() => (window.location.href = '/contact')}>
						Contact Us
					</button>
				</div>
			</section>
		</div>
	);
}

export default Home;
